export default "__VITE_ASSET__BvsHvdih__"